import {
  makePaymentDashboardBalanceUnavailableElem,
  makePaymentDashboardBalanceAttorneyElem,
  makePaymentDashboardBalanceElem,
  makePaymentDashboardBalanceAmountElem,
  makePaymentDashboardBalanceDateElem,
  makePaymentDashboardLastPaymentDateElem,
  makePaymentDashboardLastPaymentInfoElem
} from './constants'

export function paymentDashboardBalance (payment) {
  if (payment.service_unavailable) {
    paymentDashboardBalanceUnavailable()
  } else {
    if (payment.balance == null) {
      paymentDashboardBalanceUnavailable()
    } else {
      makePaymentDashboardBalanceElem.addClass('hide');
      makePaymentDashboardBalanceAttorneyElem.addClass('hide');

      if (paymentShowAttorneyBalance(payment)) {
        makePaymentDashboardBalanceAttorneyElem.removeClass('hide');
      } else {
        makePaymentDashboardBalanceAmountElem.html(payment.formatted_balance);
        makePaymentDashboardBalanceElem.removeClass('hide');
      }
    }

    if (payment.last_updated_at !== null) {
      makePaymentDashboardBalanceDateElem.html(`${payment.unit_name} - Last updated ${payment.last_updated_at}`);
    }

    if (payment.last_payment_date !== null) {
      makePaymentDashboardLastPaymentDateElem.html(`Last Payment Made: ${payment.last_payment_date}`)
      makePaymentDashboardLastPaymentInfoElem.removeClass('hide')
    }
  }
}

export function paymentShowAttorneyBalance (payment) {
  return makePaymentDashboardBalanceAttorneyElem.length > 0 && !payment.allow_payments;
}

function paymentDashboardBalanceUnavailable () {
  makePaymentDashboardBalanceUnavailableElem.removeClass('hide')
}
